let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("liNtV")).then(() => parcelRequire('395L3'));